/**
 * Registro central de workflows disponibles.
 * Para agregar un nuevo workflow, solo importa y agrega aquí.
 */

import * as eppWorkflow from './epp';
import * as residuosWorkflow from './residuos'; // ✅ ACTIVADO
// import * as combustiblesWorkflow from './combustibles';  // 🔮 Futuro

export const workflowRegistry = {
	epp: eppWorkflow,
	residuos: residuosWorkflow, // ✅ ACTIVADO
	// combustibles: combustiblesWorkflow,  // 🔮 Descomentar cuando esté listo
};

/**
 * Obtiene la configuración de un workflow por su categoría
 */
export const getWorkflowConfig = category => {
	return workflowRegistry[category] || null;
};

/**
 * Lista de categorías disponibles para el selector
 */
export const getAvailableCategories = () => {
	return Object.entries(workflowRegistry).map(([key, workflow]) => ({
		value: key,
		label: workflow.config.shortLabel || workflow.config.label,
		item: { _id: key, name: workflow.config.shortLabel || workflow.config.label },
	}));
};

